import {useState, useRef, useEffect} from 'react';
import {Row, Col, Form, Button, Modal} from 'react-bootstrap'
import { iminioBackend } from '../../api/iminio_provider';
import IminioButton from '../iminio_comps/buttons/IminioButton'
import DatePicker from "react-datepicker";
import i18n from '../../plugins/i18n';
import IminioInterventionPhotoButton from '../iminio_comps/buttons/IminioInterventionPhotoButton';

function EditCondominiumForm({ listId, userGroup, userId,  interventionData, userList, categoryList, reloadList, enableEditPhotos }) {

    let isMounted = false

    const parseDateTime = (datetime) => {
        let final = ""
        if(!datetime) return true;
        datetime = datetime.trim()
        const splitted = datetime.split(' ')
        if(splitted.length===1)
            splitted.push("")
        if(splitted.length < 2) return false
        const date = splitted[0]
        const time = splitted[1]
        const splittedDate = date.split('/')
        if(splittedDate.length !== 3) return false
        const yearIndex = splittedDate.findIndex(e=>e.length===4)
        if(!yearIndex || yearIndex !== 2) return false
        if(splittedDate[yearIndex].length < 4) return false
        final = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
        if(!time || time.length === 0) return `${final}T00:00:00.000Z`
        const splittedTime = time.split(':')
        if(splittedTime.length !== 2) return false
        if(splittedTime[0].length!==2 || splittedTime[1].length!==2)
            return false
        if(isNaN(parseInt(splittedTime[0]))===true) return false
        if(isNaN(parseInt(splittedTime[1]))===true) return false
        const parsedH = parseInt(splittedTime[0])
        const parsedM = parseInt(splittedTime[1])
        if(parsedH[0]<0||parsedH[0]>24) return false
        if(parsedM[1]<0||parsedM[1]>59) return false
        final = `${final}T${splittedTime[0]}:${splittedTime[1]}:00.000Z`
        return final
    }


    const [isLoading, setLoading] = useState(true);
    const [isEditing, setEditing] = useState(false);
    const [isDeleting, setDeleting] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false)
    const [showMessage, setShowMessage] = useState(false);
    const [showError, setShowError] = useState("");
    const [reloadAlbum, setReloadAlbum] = useState(false);
    const [showFinishedAt, setShowFinishedAt] = useState(false)
    const [activityAtField, setActivityAtField] = useState(null)
    const [finishedAtField, setFinishedAtField] = useState(null)

    const statusField = useRef(interventionData.status)
    const categoryField = useRef(interventionData.category?.id)
    const notesField = useRef(interventionData.notes)
    const assignedUserField = useRef(interventionData?.user?.id)

    const chooseStatusColor = (status)=>{
        switch(status){
          case 'pending':     return 'fg-red'
          case 'in_progress': return 'fg-yellow'
          case 'completed':   return 'fg-orange'
          case 'closed':      return 'fg-green'
          default: return ''
        }
      }

    const chooseStatusIcon = (status)=>{
        switch(status){
          case 'pending':     return 'mdi-account-alert'
          case 'in_progress': return 'mdi-repeat'
          case 'completed':   return 'mdi-check-circle'
          case 'closed':      return 'mdi-folder-check'
          default:            return ''
        }
      }

    const handleSubmitEdit = async () => {
        setLoading(true)
        setShowError("")
        let statusValue = statusField.current.value
        let validatedActivityAt = ""
        if(userGroup === 'admin'){
            if(!activityAtField || activityAtField?.length===0){
                setTimeout(() => {
                    setLoading(false)
                    setShowError("Data Intervento è un campo obbligatorio richiesto.")
                }, 300);
                return
            }
        }
        if(statusValue === 'completed' || statusValue === 'closed'){
            if(!finishedAtField || finishedAtField?.length===0){
                setTimeout(() => {
                    setLoading(false)
                    setShowError("Data di Completamento è un campo obbligatorio richiesto.")
                }, 300);
                return
            }
            try{
                if(finishedAtField?.toISOString()?.substring(0,10)<activityAtField?.toISOString()?.substring(0,10)){
                    setTimeout(() => {
                        setLoading(false)
                        setShowError("Data di Completamento non può essere anteriore a Data Intervento.")
                    }, 300);
                    return
                }
            }
            catch(e){
                console.log(e)
                setTimeout(() => {
                    setLoading(false)
                    setShowError("Campo Data di Completamento è compilato erroneamente.")
                }, 300);
                return false
            }
        }
        let data = {
            notes: notesField.current.value,
            status: statusField.current.value,
            finished_at: finishedAtField,
        }
        if(userGroup === 'admin'){
            data['category_id'] = categoryField.current.value
            data['assigned_to_id'] = assignedUserField.current.value
            if(userGroup === 'admin')
                data['activity_at'] = new Date(activityAtField)
            console.log(data)
        }
        // Quando un tecnico apre un intervento urgente (cambia status a in_progress),
        // includere l'amministratore nelle notifiche
        if(userGroup === 'technician' && 
           statusValue === 'in_progress' && 
           interventionData.category?.codename === 'urgent' &&
           interventionData.status !== 'in_progress') {
            data['notify_admin'] = true
        }
        await iminioBackend.edit_technical_intervention(interventionData.id, data)
        .then(response=>{
            interventionData.status = response.status
            const statusIcon = document.getElementById(`${listId}-status-icon`)
            const statusText = document.getElementById(`${listId}-status-text`)
            const category = document.getElementById(`${listId}-category`)
            const assignedTo = document.getElementById(`${listId}-assigned_to`)
            const status = fetchStatusList()?.filter(e=>e.key===response.status)?.[0]?.text
            statusIcon.className = ''
            statusIcon.className = `mdi ${chooseStatusIcon(response.status)} me-1 ${chooseStatusColor(response.status)}`
            if(statusText!=null)
                statusText.innerHTML= window.innerWidth < 900? '' : status
            const catFound = fetchCategoryList()?.filter(e=>e.id===response.category_id)?.[0]?.text
            category.innerHTML= window.innerWidth < 900? catFound[0] : catFound
            if(assignedTo != null){
                const user = userList?.choices?.filter(e=>e.value===response.assigned_to_id)?.[0]
                assignedTo.innerHTML=user?.text
            }
            setTimeout(() => {
                setShowMessage("Salvato con successo!")
                setLoading(false)
                setEditing(false)
            }, 300);
            setTimeout(()=>{setShowMessage("")}, 3600)
        }).catch(e=>{
            setLoading(false)
            switch(e.response?.data?.status?.code){
                case 'ERR_INVALID_FIELDS':
                    let details = e.response.data.details[0]
                    if(details.code==='string.empty')
                        setShowError(i18n.t('errors.required_field').replace('{1}', i18n.t(`models.technical_intervention.fields.${details.field}`)))
                    else if(['number.base', 'string.pattern.base', 'date.base', 'any.base', 'string.email'].includes(details.code))
                        setShowError(i18n.t('errors.invalid_field').replace('{1}', i18n.t(`models.technical_intervention.fields.${details.field}`)))
                    else
                        setShowError(i18n.t('errors.unknown'))
                    break;
                case 'ERR_ALREADY_EXISTS':
                    let details2 = e.response.data.details
                    setShowError(`${i18n.t(`models.technical_intervention.fields.${details2.field}`)} ${details2.value} `+i18n.t('errors.already_in_use'))
                    break;
                default:
                    setShowError(i18n.t('errors.unknown'))
                    break;
            }
            console.log(e)
        })
    }

    const handleSubmitDelete = async () => {
        let func = iminioBackend.delete_technical_intervention
        if(interventionData.is_deleted===true)
            func = iminioBackend.restore_technical_intervention
        setLoading(true)
        await func(interventionData.id).then(response=>{
            setLoading(false)
            setDeleting(false)
            reloadList()
        }).catch(e=>{
            console.log(e)
            setLoading(false)
            setEditing(false)
        })
    }

    const handleCancelEdit = () => {
        setShowError(false)
        setLoading(false)
        statusField.current.value  = interventionData.status
        notesField.current.value  = interventionData.notes
        if(categoryField?.current?.value!=null)
            categoryField.current.value  = interventionData?.category?.id
        if(assignedUserField?.current?.value!=null)
            assignedUserField.current.value  = interventionData?.user?.id
        if(finishedAtField!=null)
            setFinishedAtField(interventionData?.finished_at)
        setShowFinishedAt(interventionData.status==='completed'||interventionData.status==='closed')
        setEditing(false)
    }

    const fetchStatusList = () => {
        return [
            { key:"pending", text: i18n.t('models.technical_intervention.status.pending')},
            { key:"in_progress", text: i18n.t('models.technical_intervention.status.in_progress')},
            { key:"completed", text: i18n.t('models.technical_intervention.status.completed')},
            { key:"closed", text: i18n.t('models.technical_intervention.status.closed')},
        ]
    }

    const fetchCategoryList = () => {
        return !categoryList? [] : categoryList.choices.map(e=>{
            return { id: e.id, key:e.value, text: e.text}
        })
    }

    // const fetchUserList = async () => {
    //     return await iminioBackend.list_users({}).then(response=>{
    //         setUserList(response.users);
    //     }).catch(e=>console.log(e))
    // }

    useEffect(()=>{
        const init = async () => {
            // await fetchUserList()
            setActivityAtField(interventionData?.activity_at? new Date(interventionData?.activity_at?.substring(0,10)) : interventionData?.activity_at)
            let finished_at = interventionData?.finished_at
            if (finished_at?.indexOf('/') >= 0)
                finished_at = parseDateTime(finished_at)
            setFinishedAtField(
                finished_at ? 
                    new Date(finished_at)
                    :
                    new Date()
            )
            setShowFinishedAt(interventionData.status==='completed'||interventionData.status==='closed')
            setTimeout(()=>{setLoading(false)},300)
        }
        if(isMounted===false){
            init()
            isMounted=true
        }
    }, [])

    const submitNewPhoto = async (base64, note) => {
        await iminioBackend.attach_technical_intervention_photo(interventionData.id, base64, note).then(
            response=>{
                setShowMessage("Foto Caricata con Successo")
                interventionData.photos.push({id:response.photo.id, thumbnail:base64})
                setLoading(false)
                setTimeout(()=>{setShowMessage("")}, 3600)
            }
        )
    }

    const handlePhotoDelete = (photo) => {
        interventionData.photos = interventionData.photos.filter(it=>it.id!==photo.id)
        setReloadAlbum(true)
        setTimeout(() => {setReloadAlbum(false) }, 50);
    }

    const handleDownloadPDF = async () => {
        setLoading(true);
        try {
            await iminioBackend.download_technical_intervention_pdf(interventionData.id);
            setShowMessage("PDF scaricato con successo");
            setTimeout(() => {setShowMessage("")}, 3600);
        } catch (e) {
            console.log(e);
            setShowError("Errore durante il download del PDF");
            setTimeout(() => {setShowError("")}, 3600);
        } finally {
            setLoading(false);
        }
    }

    return <>
        <Row id="intervention-edit-form-container">
            <Col xs={12} md={6} className="justify-content-start pe-4">
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Form.Label column xs="12">
                        <span className="fg-orange"><b>Foto:</b></span>
                    </Form.Label>
                    <Col xs="12">
                        {reloadAlbum?'':<IminioInterventionPhotoButton 
                            interventionId={interventionData.id}
                            photos={interventionData.photos}
                            disabled={isLoading || (userGroup!=='admin'&&userId!==interventionData?.user?.id)} 
                            onClickUpload={submitNewPhoto}
                            onDelete={handlePhotoDelete}
                            enableDelete={isEditing===true}
                            enableEditPhotos={enableEditPhotos}
                        />}
                    </Col>
                </Form.Group>
            </Col>
            { userGroup === 'technician' ? '' : <Col xs={7} md={3} className="justify-content-start">
                <Form.Label column xs="12">
                    <span className="fg-orange"><b>{i18n.t('models.technical_intervention.fields.status')}:</b></span>
                </Form.Label>
                <Form.Select ref={statusField} defaultValue={interventionData?.status} onChange={(ev)=>{
                    setShowFinishedAt(ev.target.value==='completed'||ev.target.value==='closed')
                }} disabled={!isEditing || isLoading}>
                    {fetchStatusList().map(e=>{
                        return <option key={`interstatus-${e.key}`} value={e.key}>{e.text}</option>
                    })}
                </Form.Select>
                <Form.Label column xs="12" className="mt-3">
                    <span className="fg-orange"><b>{i18n.t('models.technical_intervention.fields.assigned_to')}:</b></span>
                </Form.Label>
                <Form.Select ref={assignedUserField} defaultValue={interventionData?.user?.id} disabled={!isEditing || isLoading}>
                    <option value="">Seleziona Utente</option>
                    {!userList ? '' : userList.choices.map(e=>{
                        return <option key={`interutente-${e.value}`} value={e.value}>{e.text}</option>
                    })}
                </Form.Select>
            </Col>}
            { userGroup === 'technician' ? '' : 
            <Col xs={7} md={3} className="justify-content-start">
                <Form.Label column xs="12">
                    <span className="fg-orange"><b>{i18n.t('models.technical_intervention.fields.category')}:</b></span>
                </Form.Label>
                <Form.Select ref={categoryField} defaultValue={interventionData?.category?.id} disabled={!isEditing || isLoading}>
                    {fetchCategoryList().map(e=>{
                        return <option key={`intercategory-${e.id}`} value={''+e.id}>{e.text}</option>
                    })}
                </Form.Select>
                <Form.Label column xs="12" className="fg-orange mt-3">
                    <span><b>Data Intervento:</b></span>
                </Form.Label>
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                    <Col xs="12" className="ps-3">
                        <div className="d-flex flex-row justify-content-end">
                            <i className="mdi mdi-calendar text-14 me-2"></i>
                            <DatePicker 
                                selected={activityAtField} 
                                onChange={(date) =>  setActivityAtField(date)} 
                                disabled={!isEditing || isLoading}
                                dateFormat="dd/MM/yyyy"
                            />

                        </div>
                    </Col>
                </Form.Group>
                <>
                { showFinishedAt===true ? 
                <>
                    <Form.Label column xs="12" className="fg-orange">
                        <span><b>Data di completamento:</b></span>
                    </Form.Label>
                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                        <Col xs="12" className="ps-3">
                            <div className="d-flex flex-row justify-content-end">
                                <i className="mdi mdi-calendar text-14 me-2"></i>
                                <DatePicker 
                                    selected={finishedAtField} 
                                    onChange={(date) =>  setFinishedAtField(date)} 
                                    disabled={!isEditing || isLoading}
                                    dateFormat="dd/MM/yyyy"
                                />
                            </div>
                        </Col>
                    </Form.Group>
                </>
                :''
                }
                </>
            </Col>}
            <Col xs={12} md={6}>
                { userGroup !== 'technician' ? '' : <Col xs={12} className="justify-content-start">
                    <Row className="align-items-center">
                        <Col xs={12} md={3} className="me-2">
                            <Form.Label column xs="12">
                                <span className="fg-orange"><b>{i18n.t('models.condominium.single')}:</b></span>
                            </Form.Label>
                            <span className="ps-2">{interventionData.condominium?.name}</span>
                        </Col>
                        <Col xs={8} md={4}>
                            <Form.Label column xs="12">
                                <span className="fg-orange"><b>{i18n.t('models.condominium.fields.managed_by')}:</b></span>
                            </Form.Label>
                            <span className="ps-2 pe-2">{`${interventionData.condominium?.managed_by.first_name} ${interventionData.condominium?.managed_by.last_name}`}</span>
                            {/* -
                            <span className="ps-2">{`${interventionData.condominium?.managed_by.email}`}</span>
                            {!interventionData.condominium?.managed_by.phone ? '' : <span className="ps-4">{`${interventionData.condominium?.managed_by.phone}`}</span>} */}
                        </Col>
                        <Col xs={3} className="align-content-end pt-3">
                            <IminioButton 
                                    label="Contattare" 
                                    icon="mdi mdi-phone" 
                                    color="bg-orange" 
                                    textColor="fg-white" 
                                    size='sm'
                                    onClick={()=>setShowContactModal(true)}
                                />
                                <Modal show={showContactModal} onHide={()=>{setShowContactModal(false)}}>
                                    <Modal.Header closeButton>
                                        <h6>{interventionData.condominium?.managed_by.first_name} {interventionData.condominium?.managed_by.last_name}</h6>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <Col xs={12} style={{width: "400px"}}>
                                            <Row>
                                                <Col xs={3}>
                                                    <span>{i18n.t('models.user.fields.email')}:</span>
                                                </Col>
                                                <Col xs={9}>
                                                    {interventionData.condominium?.managed_by.email}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={3}>
                                                    <span>{i18n.t('models.user.fields.phone')}:</span>
                                                </Col>
                                                <Col xs={9}>
                                                    {interventionData.condominium?.managed_by.phone}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <IminioButton label="Ok" color="bg-orange" textColor="fg-white" onClick={()=>setShowContactModal(false)}></IminioButton>
                                    </Modal.Footer>
                                </Modal>
                        </Col>
                        <Col xs={12} md={4} className="">
                            <Form.Label column xs="12">
                                <span className="fg-orange"><b>{i18n.t('models.technical_intervention.fields.status')}:</b></span>
                            </Form.Label>
                            {
                                userGroup==='technician' && interventionData?.status === 'closed' ? 
                                <span>Chiuso</span>
                                :
                                <Form.Select ref={statusField} defaultValue={interventionData?.status} disabled={!isEditing || isLoading}
                                    onChange={(ev)=>{
                                        setShowFinishedAt(ev.target.value==='completed'||ev.target.value==='closed')
                                    }}
                                >
                                    {fetchStatusList().map(e=>{
                                        if(e.key==='closed') return ''
                                        return <option key={`interstatus-${e.key}`} value={e.key}>{e.text}</option>
                                    })}
                                </Form.Select>
                            }
                        </Col>
                        {showFinishedAt && 
                        <Col xs={12} md={6} className="ms-2">
                            <Form.Label column xs="12" className="fg-orange">
                                <span><b>Data di completamento* :</b></span>
                            </Form.Label>
                            <Form.Group as={Row} className="" controlId="formPlaintextEmail" style={{position:'relative'}}>
                            <Col xs="12" className="ps-3">
                                <div className="d-flex flex-row justify-content-end">
                                    <i className="mdi mdi-calendar text-14 me-2"></i>
                                    <DatePicker 
                                        selected={finishedAtField} 
                                        onChange={(date) =>  setFinishedAtField(date)} 
                                        disabled={!isEditing || isLoading}
                                        dateFormat="dd/MM/yyyy"
                                    />
                                </div>
                            </Col>
                            </Form.Group>
                        </Col>}
                    </Row>
                </Col>}
                <Col xs={12}>
                    { userGroup === 'technician' ? '' : <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                        <Form.Label column xs="12">
                            <span className="fg-orange"><b>Note Intervento:</b></span>
                        </Form.Label>
                        <Col xs="1"></Col>
                        <Col xs="12">
                            <Form.Control 
                                as="textarea" 
                                ref={notesField} 
                                plaintext={!isEditing && !isLoading} 
                                readOnly={!isEditing && !isLoading} 
                                defaultValue={interventionData.notes} 
                            />
                        </Col>
                    </Form.Group>}
                </Col>
                { userGroup === 'admin' ? '' : <Col xs={12}>
                    <Form.Group as={Row} className="mb-2 mt-3" controlId="formPlaintextEmail">
                        <Form.Label column xs="12">
                            <span className="fg-orange"><b>Note Intervento:</b></span>
                        </Form.Label>
                        <Col xs="1"></Col>
                        <Col xs="12" className="ps-2">
                            <Form.Control 
                                as="textarea" 
                                ref={notesField} 
                                plaintext={!isEditing && !isLoading} 
                                readOnly={!isEditing && !isLoading} 
                                defaultValue={interventionData.notes} 
                            />
                        </Col>
                    </Form.Group>
                </Col>}
            </Col>
            <Row className="justify-content-end">
                    {
                        !showMessage || showMessage.length === 0 ? '' :
                        <div className="iminio-error-container bg-green fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
                            <i className="mdi mdi-check-circle me-2"></i>
                            {showMessage}
                        </div>
                    }
                    {
                        !showError || showError.length === 0 ? '' :
                        <div className="iminio-error-container bg-red fg-white justify-content-center px-4 text-9 iminio-border-round-force me-3">
                            <i className="mdi mdi-close-circle me-2"></i>
                            {showError}
                        </div>
                    }
            </Row>
            { userGroup ==='technician' && userId !== interventionData?.user?.id ? '' :
            <Col xs={12} className="d-flex justify-content-end align-items-center mt-2">
                {
                    !isEditing ? '' :
                    <Col xs={12} md={4} className="d-flex justify-content-end align-content-end">
                        <Button className={`px-4 me-2 corner-round bg-gray-darker fg-text`} variant="orange" disabled={isLoading} onClick={()=>{handleCancelEdit()}} size={'sm'}>
                            <i className="mdi mdi-close me-2"></i>
                            Cancella
                        </Button>
                        <Button className={`px-5 corner-round bg-orange fg-white`} variant="orange" disabled={isLoading} onClick={()=>{handleSubmitEdit()}} size={'sm'}>
                            <i className="mdi mdi-content-save me-2"></i>
                            Salva
                        </Button>
                    </Col>
                }
                {
                    userGroup==='technician' && interventionData.status==='closed' ? '' :
                    isEditing || isDeleting ? '' :
                    <Col xs={12} md={4} className="d-flex justify-content-end align-content-end">
                        <Button className={`px-3 corner-round bg-orange fg-white`} variant="orange" onClick={()=>{setEditing(true)}} size={'sm'}>
                            <i className="mdi mdi-square-edit-outline me-2"></i>
                            Modifica
                        </Button>
                        {
                            userGroup!=='admin' ? '' :
                            <>
                            <div className="divider-v mx-4"></div>
                            {interventionData.is_deleted===false ? 
                                <Button className={`px-3 corner-round bg-red fg-white`} variant="red" onClick={()=>{setDeleting(true)}} size={'sm'}>
                                    <i className="mdi mdi-delete me-2"></i>
                                    Eliminare
                                </Button>
                            :
                                <Button className={`px-3 corner-round bg-green fg-white`} variant="red" onClick={()=>{setDeleting(true)}} size={'sm'}>
                                    <i className="mdi mdi-delete-restore me-2"></i>
                                    Ripristinare
                                </Button>}
                            </>
                        }
                        {
                            userGroup==='admin' && interventionData.status==='closed' && !isEditing && !isDeleting ? 
                            <>
                                <div className="divider-v mx-4"></div>
                                <Button className={`px-3 corner-round bg-blue fg-white`} variant="blue" onClick={handleDownloadPDF} size={'sm'} disabled={isLoading}>
                                    <i className="mdi mdi-file-pdf-box me-2"></i>
                                    Scarica PDF
                                </Button>
                            </>
                            : ''
                        }
                    </Col>
                }
                {
                    !isDeleting ? '' :
                    <>
                        Vuoi {interventionData.is_deleted===false?'eliminare':'rirpistinare'} questo intervento?
                        <Button className={`ms-3 px-3 corner-round bg-orange fg-white`} variant="orange" onClick={()=>{setDeleting(false)}} size={'sm'}>
                            No
                        </Button>
                        <div className="divider-v mx-4"></div>
                        <Button className={`px-3 corner-round ${interventionData.is_deleted===false?'bg-red':'bg-green'} fg-white`} variant="red" onClick={()=>{handleSubmitDelete()}} size={'sm'}>
                            Si
                            <i className="mdi mdi-delete ms-2"></i>
                        </Button>
                    </>
                }
            </Col>
            }
        </Row>
    </>;
}

export default EditCondominiumForm